import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { listStyles } from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import { GridOffset } from "@insite/mobius/GridContainer/GridContainer";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

Object.assign(listStyles, {
    ...listStyles,
    wrapper: {
        css: css`
            margin-top: 20px;
            margin-bottom: 20px;
            border-top: 1px solid ${getColor("common.border")};
        `,
    },
    cardList: {
        gridContainer: {
            gap: 0,
            css: css`
                ${GridOffset} {
                    justify-content: flex-start;
                }
            `,
        },
    },
});
